import { render, staticRenderFns } from "./donors-provider.vue?vue&type=template&id=d8fa9444&scoped=true&"
import script from "./donors-provider.vue?vue&type=script&lang=js&"
export * from "./donors-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fa9444",
  null
  
)

export default component.exports